import { useContext } from 'react';
import { WorkflowContext } from './WorkflowProvider';

export const useWorkflowContext = () => {
  const context = useContext(WorkflowContext);

  if (context === undefined) {
    throw new Error('useWorkflowContext must be used within a WorkflowProvider');
  }

  return context;
};
